import { defineStore } from 'pinia';
import { ref, shallowRef } from 'vue';

export interface Theme {
  backgroundColor: string;
  foregroundColor: string;
  secondaryColor: string;
  buttonColor: string;
  backgroundImage: string | undefined;
  backgroundRepeat: boolean | undefined;
}

export const useThemeStore = defineStore('theme', () => {
  const theme = shallowRef<Theme>({
    backgroundColor: '#ffffff',
    foregroundColor: '#333',
    secondaryColor: 'pink',
    buttonColor: 'red',
    backgroundImage: '',
    backgroundRepeat: true,
  });

  function setTheme(newTheme: Theme) {
    theme.value = newTheme;
  }

  return {
    // State
    theme,

    // Actions
    setTheme,
  };
});
